


































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {CustomerDto} from '@/dto/CustomerDto';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import {QingAppDto} from '@/dto/QingAppDto';
import {QingApp} from '@/entity/QingApp';
import {getModule} from 'vuex-module-decorators';
import {CustomerStore} from '@/store/CustomerStore';
import QingAppForm from '@/components/QingApp/QingAppFormE.vue';
import KeShangMain from "@/views/KeShangMain.vue";
import {Customer} from "@/entity/Customer";
import {BaseStore} from '@/store/BaseStore';
import EbyChatPage from "@/views/EbyChatPage.vue";
import {AuthStore} from '@/oauth/AuthStore';
import {ConsumerLightAppRelationDto} from '@/dto/ConsumerLightAppRelationDto';
import {ConsumerLightAppRelationReq} from "@/entity/ConsumerLightAppRelationReq";
import {ConsumerLightAppRelationEntity} from "@/entity/ConsumerLightAppRelationEntity";
import {QueryRelationInfoDto} from "@/dto/queryRelationInfoDto";
import {UserInfoEntity} from '@/entity/UserInfoEntity';
import {RealTimeInfoStore} from "@/store/RealTimeInfoStore";
import {UserInfoEntityDto} from "@/dto/UserInfoEntityDto";
import {CompanyInfo} from "@/entity/CompanyInfo";

@Component({
  components: {EbyChatPage, KeShangMain, QingAppForm},
})
export default class QingAppList extends Vue {
  isManage = false;
  isEditShow = false;
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);
  su = SecurityUtils;
  editQingApp = new QingApp();
  private qingApps: QingApp[] = [];
  customer = new Customer();
  slide = '1';
  navPos = 'bottom';
  // url = '';
  Show = false
  collectAppName = ''

  //从监听消息里面拿数据
  bs = getModule(BaseStore)

  currMoveApp = new QingApp()
  currMoveIndex = 0

  appStart(qingApp: QingApp, index: number) {
    this.currMoveApp = qingApp;
    this.currMoveIndex = index
    // console.log("开始移动",qingApp,index)
  }

  appOver(ev: any) {
    ev.preventDefault()
  }

  drop(index: number) {
    // console.log("放下",index)
    if (index == this.currMoveIndex) return false
    // console.log("从"+this.currMoveIndex+"移动到"+index)
    this.qingApps.splice(this.currMoveIndex, 1)
    this.qingApps.splice(index, 0, this.currMoveApp)

    const consumerLightAppRelationReq = new ConsumerLightAppRelationReq()
    consumerLightAppRelationReq.userName = this.ls.loginUser.username
    for (let i = 0; i < this.qingApps.length; i++) {
      const consumerLightAppRelationEntity = new ConsumerLightAppRelationEntity()
      consumerLightAppRelationEntity.lightAppId = this.qingApps[i].id as unknown as string
      consumerLightAppRelationEntity.lightAppSort = (i + 1).toString()
      consumerLightAppRelationReq.consumerLightAppRelationEntityList.push(consumerLightAppRelationEntity)
    }
    // consumerLightAppRelationReq.consumerLightAppRelationEntityList = this.qingApps
    console.log(consumerLightAppRelationReq)
    ConsumerLightAppRelationDto.saveRelationInfo(consumerLightAppRelationReq)

  }

  get tab() {
    return this.bs.ebyMessage.tabName
  }

  get url() {
    return this.bs.ebyMessage.url
  }

  get phone() {
    return this.bs.ebyMessage.phone
  }

  get personName() {
    return this.bs.ebyMessage.personName
  }

  open() {
    this.Show = true;
  }

  close() {
    this.Show = false;
    sessionStorage.removeItem('qingAppName');
    sessionStorage.setItem("goback", "2");
  }

  goBack() {
    window.history.go(-1);
    // window.history.back();
    sessionStorage.removeItem('qingAppName');
  }

  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }

  async getCustomerList() {
    const c = await CustomerDto.findById(Number(this.id));
    this.cs.setCurrentCustomer(c);
    // await this.getQingAppList();
    await this.showQingApp()

  }

  get hasAdminRole() {
    console.log(this.id);
    const role = 'ROLE_CUSTOMER_' + this.id + '_ADMIN';
    return this.su.getToken().getAuthoritys().some(value => {
      // console.log(value.includes(role), value, role);
      return value.includes(role);
    });
  }

  handleAdd() {
    this.editQingApp.customerId = Number(this.id);
    this.isEditShow = true;
  }

  handleSubmit() {
    this.isEditShow = false;
    //this.getQingAppList();
  }

  async getQingAppList() {
    const qingApp = new QingApp();
    // qingApp.userName=this.su.
    // console.log(this.ls.loginUser.username)
    qingApp.userName = this.ls.loginUser.username
    let qingApps = await QingAppDto.findAll(qingApp);
    // console.log(qingApps)
    // console.log('getQingAppList', this);
    if (!this.isManage) {
      qingApps = qingApps.filter(q => {
        switch (q.showType) {
          case 0:
            return true;
          case 1:
            return q.showUser.some(value => value === this.su.getToken().getUsername());
          case 2:
            return q.showCustomer.some(value => value === this.id);
          case 3:
            return q.showRole.some(value => this.su.getTokenAuthorities().some(value1 => value === value1));
        }
      });
    }
    this.qingApps = qingApps;

  }


  get userInfoApps() {
    // return getModule(RealTimeInfoStore).queryInfo;
    return getModule(RealTimeInfoStore).companyInfo;
  }

  @Watch('userInfoApps', {
    immediate: false,
    deep: true
  })
  async changeUserInfoApps(newVal: UserInfoEntity) {
    if (newVal !== null && newVal !== undefined) {
      const qingApp = new QingApp()
      qingApp.userName = newVal.userName;
      qingApp.companyId = newVal.companyId as string;
      qingApp.userIdentity = newVal.userIdentity as string;
      const relationInfo = await QueryRelationInfoDto.queryRelationInfo(qingApp)
      this.qingApps = relationInfo;
    } else {
      const qq = new UserInfoEntity();
      qq.userName = this.su.getLoginUser().username;
      const companyInfo: UserInfoEntity[] = await UserInfoEntityDto.selectCompanyInfo(qq);
      if (companyInfo === undefined || companyInfo === null || companyInfo.length <= 0) {
        const qingApp = new QingApp();
        qingApp.userName = this.su.getLoginUser().username;
        this.qingApps = await QueryRelationInfoDto.queryRelationInfo(qingApp)
      }
    }
    // const qingApp2: QingApp = new QingApp();
    // qingApp2.appName = '客商管理'
    // qingApp2.logo = 'img/customersManagement.svg'
    // this.qingApps.push(qingApp2)
    // const qingApp3: QingApp = new QingApp();
    // qingApp3.appName = '创建客商'
    // qingApp3.logo = 'img/createmerChant.svg'
    // this.qingApps.push(qingApp3)
    // const qingApp4: QingApp = new QingApp();
    // qingApp4.appName = '更多'
    // qingApp4.logo = 'img/more.svg'
    // this.qingApps.push(qingApp4)
  }

  get id() {
    return this.$route.params.id;
  }

  handleQingAppClick(q: QingApp) {
    // if (q.appName === '客商管理') {
    //   this.$router.push({name:'CustomerAdminTable',params:{id: this.su.getLoginUser().id as unknown as string}})
    // }
    // if (q.appName === '创建客商') {
    //   this.$router.push({name: 'KeShangRegister'})
    // }
    // if (q.appName === '更多') {
    //   return
    // }
    if (this.isManage) {
      this.editQingApp = QingApp.of(q);
      this.isEditShow = true;
    } else {
      let url = new URL(q.webUrl);
      if (this.$q.platform.is.mobile) {
        url = new URL(q.mobileUrl);
      }
      if (url.href == 'https://guard.yong-gang.cn/app/home') {
        url.searchParams.set('name', this.ls.loginUser.name)
        url.searchParams.set('username', this.ls.loginUser.username)
      } else {
        url.searchParams.set('ticket', this.su.getToken().access_token);
      }
      console.log(url);

      // openURL(url.href);


      // const iWidth = 300; //弹出窗口的宽度;
      // const iHeight = 500; //弹出窗口的高度;
      // const iTop = (window.screen.availHeight - 30 - iHeight) / 2; //获得窗口的垂直位置;
      // const iLeft = (window.screen.availWidth - 10 - iWidth) / 2; //获得窗口的水平位置;
      let openUrl = "";//弹出窗口的url
      openUrl = url.href
      this.bs.setYgUrl(openUrl)
      // this.url = openUrl
      this.collectAppName = q.appName
      // this.Show = true
      // sessionStorage.setItem("goback","2");
      // setTimeout(() => {
      //   const elementById = document.getElementById("qingAPP") as HTMLIFrameElement;
      //   // getModule(BaseStore).setYgUrl(elementById.src)
      //   // elementById.src=getModule(BaseStore).url
      //   elementById.src = getModule(BaseStore).ebyMessage.url
      // }, 100);
      this.$router.push({name: 'qingAppView', params: {collectAppName: q.appName, url: url.href}})
      // window.open(openUrl,"","height="+iHeight+", width="+iWidth+", top="+iTop+", left="+iLeft,);
    }
  }

  private async showQingApp() {
    /*
    //1.从localstorage中获取选中的组织信息
    const selectedCompanyInfo: CompanyInfo = JSON.parse(localStorage.getItem('selectedCompanyInfo') as string);
    //2.根据选中的公司信息和用户信息获取轻应用列表
    const qingApp = new QingApp();
    if(selectedCompanyInfo !== null){
      //如果有选中的组织，则将组织ID作为参数传递
      qingApp.companyId = selectedCompanyInfo.companyId;
    }
    qingApp.userName = this.su.getLoginUser().username;
    this.qingApps = await QueryRelationInfoDto.queryRelationInfo(qingApp)

     */
    this.qingApps  = JSON.parse(localStorage.getItem('appList') as string);
    /*
    const q: UserInfoEntity = JSON.parse(localStorage.getItem('demo1') as string);
    const qingApp = new QingApp()
    if (q !== null) {
      qingApp.userName = this.su.getLoginUser().username;
      qingApp.companyId = q.companyId;
      qingApp.userIdentity = q.userIdentity;
      this.qingApps = await QueryRelationInfoDto.queryRelationInfo(qingApp)
    } else {
      const qq = new UserInfoEntity();
      qq.userName = this.su.getLoginUser().username;
      const companyInfo: UserInfoEntity[] = await UserInfoEntityDto.selectCompanyInfo(qq);
      if (companyInfo === undefined || companyInfo === null || companyInfo.length <= 0) {
        qingApp.userName = this.su.getLoginUser().username;
        this.qingApps = await QueryRelationInfoDto.queryRelationInfo(qingApp)
      }
    }
     */
    // const qingApp2: QingApp = new QingApp();
    // qingApp2.appName = '客商管理'
    // qingApp2.logo = 'img/customersManagement.svg'
    // this.qingApps.push(qingApp2)
    // const qingApp3: QingApp = new QingApp();
    // qingApp3.appName = '创建客商'
    // qingApp3.logo = 'img/createmerChant.svg'
    // this.qingApps.push(qingApp3)
    // const qingApp4: QingApp = new QingApp();
    // qingApp4.appName = '更多'
    // qingApp4.logo = 'img/more.svg'
    // this.qingApps.push(qingApp4)
  }

  async mounted() {
    await this.getCustomerList();
    this.handleSubmit();
    const qingAppName = sessionStorage.getItem('qingAppName');
    if (qingAppName !== null) {
      const qingapp = this.qingApps.find(value => value.appName === qingAppName) as QingApp;
      // if (qingapp!==null){
      // console.log(this.qingApps);
      this.handleQingAppClick(qingapp);
      // }
    }
    // document.addEventListener("backbutton",evt => {
    //   console.log(evt);
    //   window.history.go(-1);
    // })
    sessionStorage.setItem("goback", "1");
    document.addEventListener("backbutton", evt => {
      // console.log(this.$route.name)
      // console.log(this.$route.path)
      // console.log(this.$route.fullPath)
      // evt.returnValue = false;
      // const win1: any = window;
      // win1.event.returnValue = false;

      // console.log(evt.returnValue);
      // console.log('++++++++++++++++++++')
      // console.log(this.Show);
      const win: any = window;
      const goback = sessionStorage.getItem("goback");
      // evt.preventDefault();
      // evt.stopPropagation();
      if (this.$route.name === "QingAppList" && goback === "1") {
        // console.log(evt);
        // window.navigator.app.exitApp();
        win.navigator.app.exitApp();
      }
      if (goback === "2") {
        window.history.go(-1);
        sessionStorage.setItem("goback", "1");
      }
      // else {
      //   window.history.go(-1);
      // }
    })
  }

}
